import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=0aad2632&scoped=true"
var script = {}
import style0 from "./Copyright.vue?vue&type=style&index=0&id=0aad2632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad2632",
  null
  
)

export default component.exports